import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { FilterPaymentIntendType, PaymentWithUserAndCoupon } from "libs/dto/src/payment";
import qs from "qs";

const getPayments = async (page: number, filter?: FilterPaymentIntendType | null | undefined) => {
  if (filter) {
    const response = await axios.get<{ page: number; data: PaymentWithUserAndCoupon[] }>(
      `/payments`,
      {
        params: {
          page,
          ...filter,
        },
        paramsSerializer: (params) => qs.stringify(params),
      },
    );
    return response.data;
  }
  const response = await axios.get<{ page: number; data: PaymentWithUserAndCoupon[] }>(
    `/payments`,
    {
      params: {
        page,
      },
      paramsSerializer: (params) => qs.stringify(params),
    },
  );
  return response.data;
};

export const usePayments = (page: number, filter?: FilterPaymentIntendType | null | undefined) => {
  const {
    data: payments,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["payments", page, filter],
    queryFn: () => getPayments(page, filter),
  });

  return { payments, loading, error };
};
